import React from 'react'
import { useState} from 'react';
import { send } from 'emailjs-com';
import swal from 'sweetalert';


const Contact = () => {

    //this part of the code sends contact us details to email

    const [toSend, setToSend] = useState({
        from_fname: '',
        from_lname: '',
        from_pnumber: '',
        to_name: 'Kirche Admin',
        message: '',
        reply_to: '',
    });

    const onSubmit = (e) => {
        e.preventDefault();
        send(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        toSend,
        process.env.REACT_APP_USER_ID,
        )
        .then((response) => {
            console.log('SUCCESS!', response.status, response.text);
            swal("Success", "Your message was sent successfully!", "success");
            const inputs = document.querySelectorAll('#firstname, #lastname, #email, #number, #message');
              inputs.forEach(input => {
              input.value = '';
              });
        })
        .catch((err) => {
            console.log('FAILED...', err);
            swal("Oops!", "Something went wrong! Check your connection and try again", "error");
        });
    };

    const handleChange = (e) => {
        setToSend({ ...toSend, [e.target.name]: e.target.value });
    };
    return(
        <section className="contact-us mt-16" id="contact">
        <div className="w-full">
          <h1 className="text-5xl text-center font-bold max-md:text-5xl max-md:text-center max-sm:text-4xl">CONTACT US</h1>
        </div>
        <div className="px-20 max-[940px]:px-10 max-sm:px-7 max-sm:text-center">
          <form className="w-full border-4 px-10 py-10 mt-10 max-sm:px-5" onSubmit={onSubmit} id="myForm">
            <h2 className="text-teal-900 text-xl">Write us a message</h2>
            <div className="grid grid-cols-2 gap-28 mt-12 w-full max-sm:grid max-sm:grid-cols-1 max-sm:gap-10 max-md:gap-5">
              <input type="text" className="w-full bg-transparent" id="firstname" placeholder="First Name" name="from_fname" value={toSend.from_fname} onChange={handleChange} required/>
              <input type="text" className="w-full bg-transparent" id="lastname" placeholder="Last Name" name="from_lname" value={toSend.from_lname} onChange={handleChange} required/>
            </div>
            <div  className="grid grid-cols-2 gap-28 mt-12 w-full max-sm:grid max-sm:grid-cols-1 max-sm:gap-10 max-md:gap-5">
              <input type="email" className="w-full bg-transparent" id="email" placeholder="Email" name='reply_to' value={toSend.reply_to} onChange={handleChange} required/>
              <input type="telephone" className="w-full bg-transparent" id="number" placeholder="Phone Number" name="from_pnumber" value={toSend.from_pnumber} onChange={handleChange} required/>
            </div>
            <div class="mt-12 w-full">
              <textarea type="text" className="w-full h-32 bg-transparent" id="message" placeholder="Type Message" name='message' value={toSend.message} onChange={handleChange} required/>
            </div>
            <button type="submit" className="px-12 py-3 text-center text-white font-semibold mt-10 drop-shadow-2xl" style={{backgroundColor: "#F17357"}} data-toggle="modal" data-target="#myModal">SUBMIT</button>
          </form>
        </div>

        {/* modal */}

      </section>
    )
    
}

export default Contact
